import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import AdoptableCountdown, {
  type AdoptableCountdownProps,
} from '@wix/da-ds/pkg/Time/AdoptableCountdown';
import s from './Countdown.scss';

interface Props extends Pick<AdoptableCountdownProps, 'countToDate' | 'onEnd'> {
  hasEnded: boolean;
  isEarlyAccess?: boolean;
  className?: string;
}

function getLabelTranslation(t, hasEnded: boolean, isEarlyAccess?: boolean) {
  if (hasEnded) {
    return t('sidebar.exclusives.countdown.label.ended');
  } else if (isEarlyAccess) {
    return t('sidebar.exclusives.countdown.label.earlyAccessTimer');
  } else {
    return t('sidebar.exclusives.countdown.label.offerTimer');
  }
}

const Countdown: React.FC<Props> = ({
  countToDate,
  onEnd,
  isEarlyAccess,
  hasEnded,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={c(s['root'], className)}>
      <div className={s['label']}>
        {getLabelTranslation(t, hasEnded, isEarlyAccess)}
      </div>
      <div className={s['value']}>
        <AdoptableCountdown
          countToDate={countToDate}
          endedClassName={s['ended']}
          endedMessage={`00:00:00`}
          onEnd={onEnd}
        />
      </div>
    </div>
  );
};

Countdown.displayName = 'Countdown';

export default Countdown;
